import { CommitmentSourcesService } from '@festina/life-general-types/life/services/CommitmentSourcesService'
import { useFestinaMutation } from '@festina-life/authentication'

const method =
  CommitmentSourcesService.commitmentSourcesExternalPayloadsServiceDeleteRejectPayload

type Props = {
  ownerId: string
  tenantId: string
}

export const useDeleteCommitmentSourceExternalPayload = ({
  ownerId,
  tenantId,
}: Props) =>
  useFestinaMutation({
    component: 'life',
    isScenario: false,
    mutateFunction: async ({
      postingId,
    }: Pick<Parameters<typeof method>[0], 'postingId'>) => {
      await method({
        ownerId,
        xTenantId: tenantId,
        postingId,
      })
    },
    roles:
      CommitmentSourcesService.commitmentSourcesExternalPayloadsServiceDeleteRejectPayload_roles,
  })
